import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PlanPackage } from '../types';

interface DeleteConfirmModalProps {
    isOpen: boolean;
    plan: PlanPackage | null;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteConfirmModal = ({ isOpen, plan, onClose, onConfirm }: DeleteConfirmModalProps) => {
    const { t } = useTranslation();

    if (!isOpen || !plan) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white dark:bg-gray-800 rounded-md shadow-xl w-full max-w-md">
                <div className="p-6">
                    <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 dark:bg-red-900/30 rounded-full">
                        <Trash2 className="h-6 w-6 text-red-600 dark:text-red-400" />
                    </div>
                    <h3 className="text-lg font-bold text-center text-gray-900 dark:text-white mb-2">
                        {t('plan.deleteConfirm.title')}
                    </h3>
                    <p
                        className="text-center text-gray-600 dark:text-gray-400"
                        dangerouslySetInnerHTML={{
                            __html: t('plan.deleteConfirm.message', { name: plan.name }),
                        }}
                    />
                </div>
                <div className="p-3 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                    >
                        {t('plan.deleteConfirm.cancel')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition"
                    >
                        {t('plan.deleteConfirm.delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};
